import { render, staticRenderFns } from "./StagePatternTable.vue?vue&type=template&id=36736998&scoped=true&"
import script from "./StagePatternTable.vue?vue&type=script&lang=js&"
export * from "./StagePatternTable.vue?vue&type=script&lang=js&"
import style0 from "./StagePatternTable.vue?vue&type=style&index=0&id=36736998&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36736998",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VDataTable,VIcon,VRow})
